import { VehiclesStoreState } from "./VehiclesStore.types";

export const vehiclesStoreState: VehiclesStoreState = {
  vehicles: [],
};
